import { RouteObject } from 'react-router-dom';
import Certificates from '@/modules/common/pages/Certificates.tsx';
import NotificationsPage from '@/modules/common/pages/NotificationsPage.tsx';
import Reports from '@/modules/common/pages/Reports.tsx';
import InvestorDashboardWrapper from '@/modules/investor-dashboard/components/InvestorDashboardWrapper.tsx';
import InvestorActivity from '@/modules/investor-dashboard/pages/InvestorActivity.tsx';
import InvestorDashboard from '@/modules/investor-dashboard/pages/InvestorDashboard.tsx';
import InvestorMyInvestments from '@/modules/investor-dashboard/pages/InvestorMyInvestments.tsx';
import InvestorTransactionsHistory from '@/modules/investor-dashboard/pages/InvestorTransactionsHistory.tsx';

export const investorDashboardPaths = {
  static: {
    dashboard: '/investor/dashboard',
    myInvestments: '/investor/my-investments',
    activity: '/investor/activity',
    transactionsHistory: '/investor/transactions-history',
    reports: '/investor/reports',
    notifications: '/investor/notifications',
    certificates: '/investor/certificates',
  },
};

export const getInvestorDashboardRoutes = () => {
  const router: RouteObject[] = [
    {
      element: <InvestorDashboardWrapper />,
      children: [
        {
          path: investorDashboardPaths.static.dashboard,
          element: <InvestorDashboard />,
        },
        {
          path: investorDashboardPaths.static.myInvestments,
          element: <InvestorMyInvestments />,
        },
        {
          path: investorDashboardPaths.static.activity,
          element: <InvestorActivity />,
        },
        {
          path: investorDashboardPaths.static.transactionsHistory,
          element: <InvestorTransactionsHistory />,
        },
        {
          path: investorDashboardPaths.static.reports,
          element: <Reports />,
        },
        {
          path: investorDashboardPaths.static.notifications,
          element: <NotificationsPage />,
        },
        {
          path: investorDashboardPaths.static.certificates,
          element: <Certificates firstColumnType="register" />,
        },
      ],
    },
  ];

  return router;
};
